<template>
  <b-card class="border card__learning-unit-members">
    <div class="font-weight-bold text-black ml-2">Instructor list</div>

    <b-list-group v-if="instructors.length">
      <b-list-group-item
        v-for="instructor in instructors"
        :key="`channel__member-${channel.url}--${instructor.id}`"
        class="d-flex flex-wrap border-0"
      >
        <b-avatar :text="instructor.userProfileText()" variant="dark" class="mr-2" />

        <div class="d-flex flex-column">
          <span class="font-weight-bold text-primary text-capitalize">
            {{ instructor.name }}
          </span>

          <small class="text-dark">{{ instructor.email }}</small>
        </div>
      </b-list-group-item>
    </b-list-group>

    <hr class="my-2 mx-3" />

    <div v-if="learner" class="font-weight-bold text-black ml-2">Learner</div>

    <b-list-group-item v-if="learner" class="d-flex flex-wrap border-0">
      <b-avatar :text="learner.userProfileText()" variant="dark" class="mr-2" />

      <div class="d-flex flex-column">
        <span class="font-weight-bold text-primary text-capitalize">
          {{ learner.name }}
        </span>

        <small class="text-dark">{{ learner.email }}</small>
      </div>
    </b-list-group-item>
  </b-card>
</template>

<script>
import Channel from '@/models/Channel';

export default {
  props: {
    channel: {
      type: Channel,
      default: null
    }
  },

  computed: {
    instructors() {
      return this.channel.teachers();
    },

    learner() {
      return this.channel.learner();
    }
  }
};
</script>

<style lang="scss" scoped>
.card__learning-unit-members {
  min-width: 300px;
}
</style>
